import * as SeparatorPrimitive from '@radix-ui/react-separator'
import { cn } from '../lib/utils'

export function Divider({
    soft = false,
    className,
    ...props
}: { soft?: boolean } & React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>) {
    return (
        <SeparatorPrimitive.Root
            orientation="horizontal"
            decorative
            {...props}
            className={cn(
                'w-full border-t',
                soft ? 'border-border/60' : 'border-border',
                className
            )}
        />
    )
}
